import {
    ASE_GENERATED_PRESIGNED_URLS,
    ASE_ATTACHMENTS_SAVED_ERROR, ASE_TICKET_ATTACHMENTS_SAVED,
} from '../../constants/websocketCommands';
import {
    ASE_ATTACHMENTS_UPLOADING,
    ASE_ATTACHMENTS_UPLOADING_ERROR
} from '../../actions/ase/actionAseAttachments';
import {ASE_TICKET_RESET} from '../../actions/ase/actionAseTicket';

export const aseAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    attachmentsForUpload: [],
}, action) => {
    switch (action.type) {
        case ASE_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case ASE_GENERATED_PRESIGNED_URLS: {
            const {attachments} = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case ASE_ATTACHMENTS_UPLOADING: {
            return Object.assign({}, state, {isTicketAttachmentUploading: true});
        }
        //att done + error
        case ASE_ATTACHMENTS_SAVED_ERROR:
        case ASE_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case ASE_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
